import React, { lazy, Suspense } from 'react'
import { DashboardLayout } from '../../layouts'
import { ListNav } from './components'
import { useDispatch, useSelector } from 'react-redux'
import { fetchOrganization } from '../../features/organization/slice'
import { Fallback } from '../../components'

const PageContent = lazy(() => import('./components/page-content'))

const DashboardProfileOrganization = () => {
  const dispatch = useDispatch()
  const organizationId = useSelector(state => state.account.profile.id)

  React.useEffect(() => {
    if(organizationId){
      dispatch(fetchOrganization(organizationId))
    }
    //eslint-disable-next-line
  }, [])

  return (
    <DashboardLayout
      title={`Organization Profile`}
      mobileNav={<ListNav />}
    >
      <Suspense fallback={<Fallback />}>
        <PageContent />
      </Suspense>
    </DashboardLayout>
  )
}

export { DashboardProfileOrganization }
